import "./scrolled";
import "./floating-logo";
import "./sliders";
import "./filters";
import "./showMore";
import "./login";
import "./mega-menu";
// import "./mmenu"
import "./menuAnchor";
import "./photos";

// scroll to system message, if any
// hack page load event with bigpipe
var checkReadyState = setInterval(() => {
  if (document.readyState === "complete") {
    clearInterval(checkReadyState);
    const sysMessage = document.querySelector(".m-alert");
    if (sysMessage) {
      const top =
        window.scrollY +
        document.querySelector(".m-alert").getBoundingClientRect().top -
        69;
      window.scroll({ top, behavior: "smooth" });
    }
  }
}, 100);
